/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Paywall_Exclusive_Tree_Dark_SubtitleInputs */

const en_daily_paywall_exclusive_tree_dark_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Even in the dark, your focus is growing.`)
};

const ar_daily_paywall_exclusive_tree_dark_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حتى في الظلام، تركيزك ينمو.`)
};

const de_daily_paywall_exclusive_tree_dark_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auch in der Dunkelheit wächst dein Fokus.`)
};

const es_daily_paywall_exclusive_tree_dark_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluso en la oscuridad, tu enfoque sigue creciendo.`)
};

const fr_daily_paywall_exclusive_tree_dark_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Même dans les ténèbres, votre concentration grandit.`)
};

const it_daily_paywall_exclusive_tree_dark_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anche nell'oscurità, la tua concentrazione cresce.`)
};

const ja_daily_paywall_exclusive_tree_dark_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暗闇の中でも、あなたの集中力は静かに育っています。`)
};

const ko_daily_paywall_exclusive_tree_dark_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어둠 속에서도 당신의 집중력은 자라납니다.`)
};

const pt_br_daily_paywall_exclusive_tree_dark_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesmo na escuridão, seu foco está crescendo.`)
};

const ru_daily_paywall_exclusive_tree_dark_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Даже во тьме ваш фокус продолжает расти.`)
};

const th_daily_paywall_exclusive_tree_dark_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แม้ในความมืด สมาธิของคุณก็ยังคงเติบโต`)
};

const tr_daily_paywall_exclusive_tree_dark_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karanlıkta bile odaklanman büyümeye devam ediyor.`)
};

const zh_cn_daily_paywall_exclusive_tree_dark_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的每一分努力，终将在暗夜中熠熠生辉。`)
};

const zh_tw_daily_paywall_exclusive_tree_dark_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Dark_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沉靜專注，你的努力終在暗夜中綻放生輝。`)
};

/**
* | output |
* | --- |
* | "Even in the dark, your focus is growing." |
*
* @param {Daily_Paywall_Exclusive_Tree_Dark_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_paywall_exclusive_tree_dark_subtitle = /** @type {((inputs?: Daily_Paywall_Exclusive_Tree_Dark_SubtitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Paywall_Exclusive_Tree_Dark_SubtitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_paywall_exclusive_tree_dark_subtitle(inputs)
	if (locale === "ar") return ar_daily_paywall_exclusive_tree_dark_subtitle(inputs)
	if (locale === "de") return de_daily_paywall_exclusive_tree_dark_subtitle(inputs)
	if (locale === "es") return es_daily_paywall_exclusive_tree_dark_subtitle(inputs)
	if (locale === "fr") return fr_daily_paywall_exclusive_tree_dark_subtitle(inputs)
	if (locale === "it") return it_daily_paywall_exclusive_tree_dark_subtitle(inputs)
	if (locale === "ja") return ja_daily_paywall_exclusive_tree_dark_subtitle(inputs)
	if (locale === "ko") return ko_daily_paywall_exclusive_tree_dark_subtitle(inputs)
	if (locale === "pt_br") return pt_br_daily_paywall_exclusive_tree_dark_subtitle(inputs)
	if (locale === "ru") return ru_daily_paywall_exclusive_tree_dark_subtitle(inputs)
	if (locale === "th") return th_daily_paywall_exclusive_tree_dark_subtitle(inputs)
	if (locale === "tr") return tr_daily_paywall_exclusive_tree_dark_subtitle(inputs)
	if (locale === "zh_cn") return zh_cn_daily_paywall_exclusive_tree_dark_subtitle(inputs)
	return zh_tw_daily_paywall_exclusive_tree_dark_subtitle(inputs)
});